import * as React from 'react';
import { Component, Handler, I18NString, isNullOrEmpty } from '../../Utils';
import {
  IControlError,
  IControlSchema,
  ValidationResult,
} from '../../Controls';
import { IDispatcher } from './Dispatcher';
//import 'react-phone-input-2/dist/style.css'
import Field from '../Field';
import Alert from '../standart/Alert';
import { isEmpty, isNull } from 'lodash';
import PhoneInput from 'react-phone-input-2';

interface TelephoneSchema extends IControlSchema {
  placeholder?: string;
  value?: string;
  description: I18NString;
  disabled?: boolean;
}

interface Props {
  schema: TelephoneSchema;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
}

interface State {
  value: string;
}

class Telephone extends Component<Props, State> {
  private input;

  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
    this.onBlur = this.onBlur.bind(this);
  }

  componentDidMount() {
    const { value } = this.props.schema;
    const error = this.props.error;
    if (!isEmpty(value) && !this.props.visited) {
      this.props.dispatcher.onVisit(this.props.schema.id);
    }

    if (error) {
      return;
    }
    const validationResult = this.validationResult(value);
    this.props.dispatcher.onBlur(
      this.props.schema.id,
      value,
      !validationResult,
      validationResult,
    );
  }

  validationResult(value: string | null | undefined): ValidationResult {
    if (!isNullOrEmpty(value) && value.replace(/\D/g, '').length >= 11) {
      return undefined;
    }

    return { message: 'Значение должно содержать больше 10 цифр' };
  }

  onBlur() {
    const value = this.input.state.formattedNumber;
    const validationResult = this.validationResult(value);
    this.props.dispatcher.onBlur(
      this.props.schema.id,
      value,
      !validationResult,
      validationResult,
    );
    this.props.dispatcher.onVisit(this.props.schema.id);
  }

  onChange() {
    const value = this.input.state.formattedNumber;
    this.setState({ value });
  }

  render() {
    let { value } = this.props.schema;
    let { error, visited } = this.props;
    value = this.state.value === null ? value : this.state.value;
    const errorMessage = visited && error && error.message;
    let statusField = 'default';
    if (errorMessage) {
      statusField = 'error';
    } else if (!isNullOrEmpty(value) && !this.props.schema.disabled) {
      statusField = 'success';
    }

    return (
      <Field {...this.props.schema} status={statusField}>
        <PhoneInput
          // @ts-ignore
          ref={(input) => (this.input = input)}
          autoFormat={true}
          defaultCountry={'ru'}
          value={!isNull(value) ? value : '+7'}
          disabled={this.props.schema.disabled}
          onChange={() => this.onChange()}
          onBlur={() => this.onBlur()}
          inputStyle={{
            width: '100%',
            borderColor: statusField !== 'success' ? '#ccc' : '#4eb43e',
          }}
          buttonStyle={{
            borderColor: statusField !== 'success' ? '#ccc' : '#4eb43e',
          }}
        />
        {errorMessage && <Alert>{errorMessage}</Alert>}
      </Field>
    );
  }
}

export function createTelephone(
  schema: IControlSchema,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  return (
    <Telephone
      schema={schema as TelephoneSchema}
      dispatcher={dispatcher}
      error={error}
      visited={visited}
    />
  );
}
